module.exports = __webpack_public_path__ + "static/mr-online-program-music-world-wide-1-f07c2a9d041706732457fa31c21b6f00.jpg";